import {useEffect} from 'react';

import DynamicPage from '@/components/DynamicPage/DynamicPage';
import PAGE_IDS from '@/consts/pageIds';
import {trackBadgesScreenViewed} from '@/services/events/loyaltyEventTracking';

const BadgesPage = ({isActive}: {isActive: boolean}) => {
    useEffect(() => {
        if (isActive) {
            trackBadgesScreenViewed();
        }
    }, [isActive]);

    return <DynamicPage pageId={PAGE_IDS.BADGES} className='pt-app-4 pb-app-menu' />;
};

export default BadgesPage;
